module.exports = __webpack_public_path__ + "static/media/logo.a2b96c7f.svg";